export class AddStudentRcModel {
    ChildTestMappingId: string;
    Score: number;
    Comments: string;
}

export class addAcademicyearModel {
    Id: string;
    YearName: string;
    SchoolId: string;

}

export class addLevelAddSchoolModel {
    Id: string;
    levels: string;
    schoolId: string;

}

export class rciModel {
    OverallComments: string;
    OverallCommentsSectionalHead: string;
    OverallCommentsHeadmaster: string;
    OverallPosition: string;
    childid: string;
    userid: string;
    testid: string;
    percentage: number;
    studentsRCModels: any = [];
    AcademicYearId: string
}

export class addSubjectsModel {
    Id: string;
    Name: string;
    Description: string;
    SchoolId: string;
    IsActive: boolean
}

export class addSubSecModel {
    SubjectName: string;
    SubjectId: string;
    Sections: any = [];
}

export class addSemesterModel {
    Id: string;
    Name: string;
    Description: string;
    SemesterId: string;
    SchoolId: string;
    IsActive: true;
    AcademicYearId: string
}

export class addSemesterTestModel {
    Id: string;
    Name: string;
    Description: string;
    SemesterId: string;
    SchoolId: string;
    IsActive: true
}


export class addgradetolevelModel{
    Id: string;
    Name: string;
}
export class addExamsModel{
    Id: string;
    Name: string;
}

export class addSubSubjectsModel {
    Id: string;
    SubSubject: string;
    SubjectId: string;
    Precentage: string;
    SubMaxMarks: boolean
}

export class postSubSubjectsModel {
    SubSubjectName: string;
    SubjectId: string;
    Percentage: string;
    SubMaxMarks: boolean
    ExcelSheetOrder: string;
}







// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/dataAnalytics/dataAnalytics.model.ts